import { Module } from 'vuex';
import type { RootState } from '@/interfaces/store';
import $rq from '@/api/api';
export interface WOTemplateState {
    woTemplate: Record<string, unknown>;
}

const defaultState: WOTemplateState = {
    woTemplate: {},
};

export const woTemplateModule: Module<WOTemplateState, RootState> = {
    state: { ...defaultState },

    getters: {
        woTemplate: (state: WOTemplateState) => state.woTemplate,
    },

    mutations: {
        setWOTemplate(state: WOTemplateState, woTemplate: Record<string, unknown>): void {
            state.woTemplate = woTemplate;
        },
        resetWOTemplate(state: WOTemplateState): void {
            Object.assign(state, { ...defaultState });
        },
    },

    actions: {
        async getWOTemplateInfo({ commit, dispatch }, contactId: string): Promise<void> {
            try {
                const { data } = await $rq.getWOTemplateInfo(contactId);
                commit('setWOTemplate', data);
            } catch (err) {
                dispatch('resetWOTemplateInfo');
            }
        },

        resetWOTemplateInfo({ commit }): void {
            commit('resetWOTemplate');
        },
    },
};
